<template>
  <div class="media-buttons">
    <button @click="openImageModal" title="Add Image">
      <img width="20" src="/images/tiptap-bar/image.svg" alt="Image" />
    </button>
    <button @click="openYoutubeModal" title="Add YouTube Video">
      <img width="20" src="/images/tiptap-bar/youtube.svg" alt="YouTube" />
    </button>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

defineProps({
  editor: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["open-image-modal", "open-youtube-modal"]);

const openImageModal = () => {
  emit("open-image-modal");
};

const openYoutubeModal = () => {
  emit("open-youtube-modal");
};
</script>

<style scoped>
.media-buttons {
  display: flex;
  gap: 10px;
}
</style>
